import React, { Suspense, useEffect } from "react";
import axiosIntegration from "../Common/Axios/axiosIntegration";
import {
  ApiConfigData,
  SectionContentMasterData,
  ShouldShowSection,
  UtilityReducer,
} from "../Utility/Utility";
import { useSelector } from "react-redux";
import API from "../Common/Endpoint/serviceConstrants";
import getTranslation from "../TranslationUtility/TranslationUtility";
import { InView } from "react-intersection-observer";
import Loader from "../Utility/Loader/Loader";

// Lazy load components
const CardSection = React.lazy(() =>
  import("../Components/CardSection/CardSection")
);
const PromoBanner = React.lazy(() =>
  import("../Components/PromoBanner/PromoBanner")
);
const WelcomeOffer = React.lazy(() =>
  import("../Components/WelcomeOffer")
);
const CustomerMenu = React.lazy(() =>
  import("../Components/CustomerMenu/CustomerMenu")
);
const SupportingBanner = React.lazy(() =>
  import("../Components/SupportingBanner/SupportingBanner")
);
const SpecialSection = React.lazy(() =>
  import("../Components/SpecialSection/SpecialSection")
);
const TopOffer = React.lazy(() => import("../Components/TopOffer/TopOffer"));
const GiftCardSection = React.lazy(() =>
  import("../Components/GiftCardSection/GiftCardSection")
);
const SpecialCartBanner = React.lazy(() =>
  import("../Components/SpecialCartBanner/SpecialCartBanner")
);
const PromoMessage = React.lazy(() =>
  import("../Components/PromoMessage/PromoMessage")
);

const FeaturedOffer = React.lazy(() =>
  import("../Components/FeaturedOffer/FeaturedOffer")
);

const HomePageHeader = React.lazy(() =>
  import("../Components/HomePageHeader/HomePageHeader")
);

const GetComponent = ({
  sectionData,
  isMobileView,
  setShowModal,
  unlockData,
  setIsLoading,
  setIsModalOpenoffer,
  isModalOpenoffer,
  setCustomeLoader,
  isMyAccountPage,
}) => {
  const translation = getTranslation();
  const login = sessionStorage.getItem("login");
  const card = UtilityReducer();
  const creditCards = card?.creditCards?.filter(card => card?.status === "1");
  const creditCardsWithExclude = card?.creditCards?.filter(card => card?.status === "1" || card?.status === "2");
  const debitCards = card?.debitCards;
  const generateToken = useSelector((state) => state.generateTokenSliceReducer);
  const apiconfig = ApiConfigData();
  const { sctionContentdata } = SectionContentMasterData();
  const partnerCode = apiconfig?.find(
    (data) => data?.paramsKey === "partnerCode"
  )?.paramsValue;
  const clientCode = apiconfig?.find(
    (data) => data?.paramsKey === "clientCode"
  )?.paramsValue;
  const isSpecialSection = sectionData?.sectionType === "Special Section";
  const filteredData = isSpecialSection
    ? sctionContentdata?.filter(
      (filterData) => filterData.sectionMasterId === sectionData.id
    )
    : [];

  useEffect(() => {
    if (login) {
      setTimeout(() => {
        sessionStorage.setItem("postLoginSuccesCount", 2);
      }, 500);
    }
  }, [login]);

  return (
    //  <InView triggerOnce={true} threshold={0.1}>
    // {({ inView, ref }) => ( 
    <div  //ref={ref}
    >
      {
        // inView?(
        // ...existing code...
        (() => {
          switch (sectionData?.sectionType) {
            case translation?.promoMessage:
              return (
                <Suspense
                  fallback={login ? <></> : <Loader />}
                >
                  <PromoMessage sectionId={sectionData?.id} login={login} />
                </Suspense>
              );

            case translation?.customerCards:
              return login && creditCards?.length ? (
                <Suspense
                  fallback={login ? <></> : <Loader />}
                >
                  <CardSection
                    card={card}
                    debitCards={debitCards}
                    creditCards={creditCards}
                    axiosIntegration={axiosIntegration}
                    generateToken={generateToken}
                    API={API}
                    clientCode={clientCode}
                    partnerCode={partnerCode}
                    sectionId={sectionData?.id}
                  />
                </Suspense>
              ) : (
                ""
              );

            case translation?.promoBanner:
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <PromoBanner
                      sectionData={sectionData}
                      text={sectionData?.text}
                      sectionId={sectionData?.id}
                      setShowModal={setShowModal}
                      login={login}
                      unlockData={unlockData}
                      creditCards={creditCards}
                      setIsLoading={setIsLoading}
                      isMobileView={isMobileView}
                      isMyAccountPage={isMyAccountPage}
                    />
                  </Suspense>
                );
              }
              return null;

            case translation?.welcomeOffer:
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <WelcomeOffer
                      sectionData={sectionData}
                      text={sectionData?.text}
                      sectionId={sectionData?.id}
                      setShowModal={setShowModal}
                      login={login}
                      unlockData={unlockData}
                      creditCards={creditCards}
                      setIsLoading={setIsLoading}
                      isMobileView={isMobileView}
                    />
                  </Suspense>
                );
              }
              return null;
            case translation?.customerMenu:
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <CustomerMenu
                      isMobileView={isMobileView}
                      text={sectionData?.text}
                      mobileHeading={sectionData?.mobileHeading}
                      sectionId={sectionData?.id}
                      setShowModal={setShowModal}
                      login={login}
                      setIsLoading={setIsLoading}
                      designLayoutType={sectionData?.designLayoutType}
                      isMyAccountPage={isMyAccountPage}
                    />
                  </Suspense>)
              }
              return null;

            case !sectionData?.isOfferListPage
              ? "Supporting Banner"
              : false:
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <SupportingBanner
                      isMobileView={isMobileView}
                      text={sectionData?.text}
                      isFullWidth={sectionData?.isFullWidth}
                      sectionId={sectionData?.id}
                      setShowModal={setShowModal}
                      login={login}
                      setIsLoading={setIsLoading}
                      sectionData={sectionData}
                    />
                  </Suspense>
                );
              }
              return null;

            case translation?.specialSection:
              const hasProducts = filteredData?.some(
                (item) => item.contentSourceType === translation?.products
              );
              const hasGiftCards = filteredData?.some(
                (item) => item.contentSourceType === translation?.giftCards
              );

              if (hasProducts) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <SpecialSection
                      setShowModal={setShowModal}
                      login={login}
                      sectionData={sectionData}
                      setIsLoading={setIsLoading}
                      isMobileView={isMobileView}
                    />
                  </Suspense>
                );
              }
              if (!hasProducts && hasGiftCards) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <GiftCardSection
                      isMobileView={isMobileView}
                      sectionData={sectionData}
                      setShowModal={setShowModal}
                      login={login}
                      setIsLoading={setIsLoading}
                    />
                  </Suspense>
                );
              }

              if (
                filteredData?.some(
                  (item) => item.contentSourceType === "Deals"
                )
              ) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <TopOffer
                      login={login}
                      setShowModal={setShowModal}
                      sectionData={sectionData}
                      setIsModalOpenoffer={setIsModalOpenoffer}
                      isModalOpenoffer={isModalOpenoffer}
                      creditCards={creditCardsWithExclude}
                      isMobileView={isMobileView}
                    />
                  </Suspense>
                );
              }
              return null;
            case translation?.offerSection || "Offer Section":
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <FeaturedOffer
                      login={login}
                      setShowModal={setShowModal}
                      sectionData={sectionData}
                      setIsModalOpenoffer={setIsModalOpenoffer}
                      isModalOpenoffer={isModalOpenoffer}
                      creditCards={creditCardsWithExclude}
                      isMobileView={isMobileView}
                      setIsLoading={setIsLoading}
                    />
                  </Suspense>
                );
              }
              return null;

            case translation?.specialCartBanner:
              return (
                <Suspense
                  fallback={login ? <></> : <Loader />}
                >
                  <SpecialCartBanner
                    setShowModal={setShowModal}
                    login={login}
                    text={sectionData?.text}
                    sectionId={sectionData?.id}
                    setIsLoading={setIsLoading}
                    isMobileView={isMobileView}
                  />
                </Suspense>
              );
            case translation?.homePageHeader:
              if (ShouldShowSection(sectionData, login, isMobileView)) {
                return (
                  <Suspense
                    fallback={login ? <></> : <Loader />}
                  >
                    <HomePageHeader
                      login={login}
                      sectionData={sectionData}
                      card={card}
                      debitCards={debitCards}
                      creditCards={creditCards}
                      axiosIntegration={axiosIntegration}
                      generateToken={generateToken}
                      API={API}
                      clientCode={clientCode}
                      partnerCode={partnerCode}
                      setCustomeLoader={setCustomeLoader}
                    />
                  </Suspense>
                );
              }
              break;
            default:
              return null;
          }
        })()
      }
    </div>
  );
};
export default GetComponent;
